import React, { useCallback, useEffect, useState } from "react";
import { toast } from "react-toastify";
import { Card, Col, Form, Row } from "react-bootstrap";
import { Accordion, AccordionItem, AccordionButton, AccordionCollapse, AccordionBody } from "react-bootstrap";
import DataTable from "react-data-table-component";
import { BsDownload, BsArrowDown, BsChevronDown } from "react-icons/bs";
import { GoAlert } from "react-icons/go";
import ReactTooltip from "react-tooltip";
import _ from "lodash";
import ButtonImage from "../../../components/UI/Button/ButtonImage";
import useApiClient, { apiRoutes } from "../../../hooks/apiClient";
import ButtonPermission from "../../../components/UI/Button/ButtonPermission";
import TextSpinner from "../../../components/UI/Spinner/TextSpinner";
import { formatarData } from "../../../components/Formatters/DateTime";
import FileDownloader from "../../../components/UI/Button/FileDownloader";
import useDocumentoSpf from "../../SPF/hooks/useDocumentoSpf";
import funcionalidades from "../../../context/AuthContext.funcionalidades";
import CNPJ from "../../../components/Formatters/CNPJ";
import CPF from "../../../components/Formatters/CPF";
import IE from "../../../components/Formatters/IE";
import constants from "../../Constants";

const documentoSpf = { exibir: () => {} };

const exibirDocumento = (row) => {
  documentoSpf.exibir(row);
};

const downloadCell = (row) => {
  if (row.documentoAssinado === null) {
    return (
      <ButtonImage
        className="btn-lg text-success pa-0 p-0"
        buttonImage={<BsDownload size="16" color="#e37023" />}
        tooltipImage={`Baixar SPF Nº ${row.numeroAberturaProcesso}`}
        onClick={() => exibirDocumento(row)}
      />
    );
  }

  return (
    <FileDownloader
      binario={row.documentoAssinado}
      tooltip={`Visualizar SPF ${row.numeroAberturaProcesso}`}
      className="ml-2"
    />
  );
};

const columns = [
  {
    name: "",
    cell: (row) => {
      let btnClass = "btn-sm text-danger pa-0 p-0";

      if (row.qtDiasAbertura < 15) {
        btnClass = "btn-sm text-success pa-0 p-0";
      } else if (row.qtDiasAbertura >= 15 && row.qtDiasAbertura < 25) {
        btnClass = "btn-sm text-alert pa-0 p-0";
      }

      return (
        <ButtonImage
          variant="bg-transparent"
          className={btnClass}
          buttonImage={<GoAlert />}
          tooltipImage={`${row.qtDiasAbertura} dias homologada`}
        />
      );
    },
    center: true,
    width: "1%",
  },
  {
    name: "Origem",
    cell: (row) => row.origem,
    maxWidth: "5%",
  },

  {
    name: "Nº SPF",
    cell: (row) => row.numeroAberturaProcesso,
    maxWidth: "7%",
    center: true,
    sortable: true,
  },
  {
    name: "Data de Inclusão",
    cell: (row) => formatarData(row.dataInclusao),
    maxWidth: "10%",
    center: true,
  },
  {
    name: "Inscrição",
    cell: (row) => <IE value={row.inscricaoEstadual} />,
    maxWidth: "10%",
    center: true,
  },
  {
    name: "CPF/CNPJ",
    cell: (row) => (row.cpfCnpj.length === 11 ? <CPF value={row.cpfCnpj} /> : <CNPJ value={row.cpfCnpj} />),
    maxWidth: "13%",
    center: true,
  },
  {
    name: "Razão Social",
    cell: (row) => (
      <div data-tag="allowRowEvents" data-tip={row.nomeFormalContribuinte}>
        <ReactTooltip place="top" type="dark" effect="float" />
        {row.nomeFormalContribuinte}
      </div>
    ),
    maxWidth: "15%",
  },
  {
    name: "Ciclo",
    cell: (row) => (
      <div data-tag="allowRowEvents" data-tip={row.descricaoCiclo}>
        {row.descricaoCiclo}
      </div>
    ),
    maxWidth: "10%",
  },
  {
    name: "Procedimentos",
    cell: (row) => (
      <div>
        {row.procedimentos.map((item) => (
          <li key={item}>{item}</li>
        ))}
      </div>
    ),
    maxWidth: "22%",
  },
];

const ListaSpfAccordion = ({ item, index, searchParameters, history, contextAction, pageSizeRows = 10 }) => {
  const [rows, setRows] = useState([]);
  const [pageSize, setPageSize] = useState(pageSizeRows);
  const [pageNumber, setPageNumber] = useState(1);
  const [totalRows, setTotalRows] = useState(1);
  const [selection, setSelection] = useState({});

  const { request, data, errors, isLoading } = useApiClient();

  useEffect(() => {
    if (!item?.sequencialTipoAcao) {
      console.error(`Erro: sequencialTipoAcao não definido para o item`);
      return;
    }
    if (item && item.sequencialTipoAcao) {
      request(apiRoutes.fiscalizacao.ordemservico.consultaSpfHomologada, {
        ...searchParameters,
        sequencialTipoAcao: item.sequencialTipoAcao,
        pageSize,
        pageNumber,
      });
    }
  }, [request, searchParameters, item, pageSize, pageNumber]);

  useEffect(() => {
    if (data?.result && data?.result?.length > 0) {
      if (data?.result?.length && !data?.result[0]?.totalRows) {
        console.error(`[DEV] A propriedade "totalRows" é obrigatória nos resultados paginados. `);
        return;
      }
      setRows(data?.result || []);
      setTotalRows(data?.result?.length ? data?.result[0]?.totalRows : 0);
    }

    if (errors) {
      toast.error(errors.message);
    }
  }, [data, errors, item]);

  const handlePageChange = useCallback((newPageNumber) => {
    setPageNumber(newPageNumber);
  }, []);

  const handlePerRowsChange = useCallback((newPageSize) => {
    setPageSize(newPageSize);
    setPageNumber(1);
  }, []);

  const prepararOs = (_index, tipoAcaoFiscal) => {
    if (selection.length > 1) {
      history.push({
        pathname: "/app/os/spf/form/lote",
        state: { listaSpf: selection, sequencialTipoAcao: tipoAcaoFiscal },
      });
    } else {
      document.getElementById(`alerta-${_index}`).innerHTML = "Selecione pelo menos 2 SPF's";
    }
  };

  // Download pdf
  if (_.last(columns).name === "Doc SPF") {
    columns.pop();
  }
  columns.push({
    name: "Doc SPF",
    cell: downloadCell,
    center: true,
    maxWidth: "6%",
  });

  const { setDocParams } = useDocumentoSpf();

  documentoSpf.exibir = (row) => {
    setDocParams({ sqAberturaProcesso: row.numeroAberturaProcesso });
  };

  return (
    <Accordion key={index}>
      <Card>
        <AccordionItem eventKey={item.descricaoTipoAcao}>
          <AccordionButton as={Card.Header}>
            <i>
              <BsChevronDown />
            </i>
            {item.descricaoTipoAcao}
          </AccordionButton>
          <AccordionCollapse eventKey={item.descricaoTipoAcao}>
            <AccordionBody>
              <DataTable
                noHeader
                keyField="numeroProcessoAbertura"
                columns={columns}
                data={rows}
                progressPending={isLoading}
                noDataComponent="Nenhum registro para exibir"
                progressComponent={<TextSpinner />}
                sortIcon={<BsArrowDown />}
                pagination
                paginationServer
                paginationTotalRows={totalRows}
                selectableRows
                pointerOnHover
                contextActions={contextAction}
                onRowClicked={(row) => {
                  history.push({
                    pathname: "/app/os/spf/form",
                    state: {
                      itemKey: row.numeroAberturaProcesso,
                      sequencialTipoAcao: row.sequencialTipoAcao,
                      contribuintes: {
                        sequencialContribuinte: row.sequencialContribuinte,
                        sequencialPessoa: row.sequencialPessoa,
                      },
                    },
                  });
                }}
                onChangeRowsPerPage={handlePerRowsChange}
                onChangePage={handlePageChange}
                paginationComponentOptions={constants.paginationComponentOptions}
                onSelectedRowsChange={(state) => {
                  setSelection(state.selectedRows);
                }}
                paginationPerPage={pageSize}
              />
              <Form.Group as={Row} className="d-flex flex-row">
                <Col sm="12">
                  <Form.Label className="small">
                    <span className="alerta" hidden={selection.length > 1} id={`alerta-${index}`}>
                      &nbsp;
                    </span>
                  </Form.Label>
                </Col>
                <Col sm="12" className="form-inline justify-content-start">
                  <ButtonPermission
                    className="mr-0 btn btn-primary btn-md btn-user"
                    name="Preparar OS em Lote"
                    permission={funcionalidades.ordemservico.inserir}
                    onClick={() => prepararOs(index, item.sequencialTipoAcao)}
                  />
                </Col>
              </Form.Group>
            </AccordionBody>
          </AccordionCollapse>
        </AccordionItem>
      </Card>
    </Accordion>
  );
};

export default ListaSpfAccordion;
